/* eslint-disable */
import { FuncoesDataHora } from 'src/componentes'

export const mensagemEtapaBloqueada = (data: Date): string =>
  `Será liberada em ${
    data.toLocaleDateString()} ${FuncoesDataHora.horaFormatada24H(data)}`
